import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import Form, { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { ButtonContainer, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../../style';
import { HotelSaleFormType } from '../form-type';
import useRecalculate from '../hooks/use-recalculate';

interface Props {
  hotelSale?: HotelSaleModel;
}

export default function SummaryHotelSale(props: Props) {
  const { t } = useTranslation();
  const { hotelSale } = props;
  const methods = useFormContext<HotelSaleFormType>();
  const {
    formState: { isSubmitting },
    reset,
  } = methods;

  const drawer = useDrawer();

  const { total } = useRecalculate();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={close} />
        </Form>
      ),
    });
  }, [drawer, methods]);

  const { editable, setIsEditable } = useFormState();

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_sales')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}>
          {`Rp. ${string2money(total)}`}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <SummaryRightContainer>
        {editable && hotelSale && !isSubmitting && (
          <>
            <ButtonContainer
              $style={{
                marginLeft: '16px',
              }}
            >
              <Button
                buttonType="secondary"
                startEnhancer={(color, size) => (
                  <CloseSVG width={size} height={size} color={color} />
                )}
                onClick={() => {
                  reset();
                  setIsEditable(false);
                }}
              >
                {t('common:cancel')}
              </Button>
            </ButtonContainer>
            <SeparatorHorizontal $margin={16} />
          </>
        )}
        <Input
          type="submit"
          overrides={{
            Root: {
              style: {
                flex: 1,
              },
            },
          }}
        />
      </SummaryRightContainer>
    </SummaryContent>
  );
}
